module.exports = __webpack_public_path__ + "static/img/2.f0ae3086.png";